import React from "react";
import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";

import SearchIcon from "@mui/icons-material/Search";

import { Link, useNavigate } from "react-router-dom";

import Searchpopup from "../ReusableComponet/Searchpopup";
import Searchbar from "../SearchBar/Searchbar";
import logo from "../../Assets/logo.svg";

import { useSelector, useDispatch } from "react-redux";
import { useAuthContext } from "../../Context/AuthContext";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import Badge from "@mui/material/Badge";
import { cartActions } from "../../redux/cartSlice";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

import { useTheme } from "@mui/material/styles";
import ReactGA4 from "react-ga4";

import Practise from "./Practise";
import { UserIcon } from "../../Icons/Icons";
import { useLogin } from "../../client-api/LoginRegister";
import "./Header.css";
import HeaderMenu from "./HeaderMenu";
import { Navigate } from "react-router-dom";
import { UsergetwishList } from "../../client-api/Apiuserdetails";
import { usePoPupContext } from "../../Context/PopupContext";
import customersupport from "../../Assets/viber.png";
import { Box, Toolbar, Divider, useMediaQuery } from "@mui/material";
import NewSearch from "../SearchBar/NewSearch";
const Headernewcentre = () => {
  function refreshPage() {
    window.location.href = "/";
  }

  const theme = useTheme();

  const { login, isLoading, error } = useLogin();
  const { user, getuserdata } = useAuthContext();

  const { setopenpopup } = usePoPupContext();

  const [search, setsearch] = useState(false);
  const [cat, setCat] = useState([]);
  const navgate = useNavigate();
  const dispatch = useDispatch();
  const { cart_items, cartCount } = useSelector((state) => state.cartUi);
  // console.log(cart_items, cartCount, "cartCount:cartCount,");
  const toggleCart = () => {
    dispatch(cartActions.toggle());
    // Track the "add_payment_info" event
    ReactGA4.event("view_cart", {
      items: cart_items.map((product) => ({
        id: product?.product?.product_id,
        name: product?.product?.name,
        slug: product?.product?.slug,
        price: product?.product?.unit_price,
        discount: product?.product?.discount_price,
        item_brand: product?.product?.brand_name,
        item_category: product?.product?.category,
        item_category2: product?.product?.childCat,
        sku_id: product?.product?.sku,
        short_description: product?.product?.short_description,
        quantity_label: product?.product?.quantity_label,
        cartCount: product?.cartCount,
      })),
    });
  };

  const [select, setSelect] = useState("US");
  const onSelect = (code) => setSelect(code);
  const userDetails = JSON.parse(localStorage.getItem("user"));

  const { data } = UsergetwishList(getuserdata);

  const handleApi = async () => {
    if (!user && !getuserdata) {
      setopenpopup("login");
    } else {
      navgate("/myAccount");
    }
  };
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <>
      <Toolbar
        sx={{
          backgroundColor: "white",
          paddingBottom: "5px",
          flexDirection: { xs: "column", md: "row" },
          gap: { xs: 2, md: 0 },
        }}
      >
        {/* Desktop layout (md and above) */}
        <Box
          sx={{
            flex: 1,
            display: { xs: "none", md: "flex" },
            justifyContent: "center",
          }}
        >
          <img
            src={logo}
            alt="logo"
            onClick={refreshPage}
            className="familylogo"
            style={{ marginTop: "10px", cursor: "pointer" }}
          />
        </Box>

        <Box
          sx={{
            flex: 2,
            width: "100%",
            display: { xs: "none", md: "flex" },
            gap: 3,
            marginTop: "auto",
          }}
        >
          <NewSearch search={search} setsearch={setsearch} />
        </Box>

        <Box
          sx={{
            flex: 1,
            display: { xs: "none", md: "flex" },
            justifyContent: "center",
            alignItems: "center",
            gap: 3,
          }}
        >
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              borderColor: "#777777",
              height: "24px",
              alignSelf: "center",
            }}
          />
          {!getuserdata?.token ? (
            <UserIcon
              onClick={() => setopenpopup("login")}
              sx={{ cursor: "pointer" }}
            />
          ) : (
            <p style={{ textTransform: "capitalize", paddingTop: "10px" }}>
              <Link to="/myAccount" style={{ textDecoration: "none", color: "black", cursor: "pointer" }}
              >    
                My Account
              </Link>
            </p>
          )}

          <Divider
            orientation="vertical"
            flexItem
            sx={{
              borderColor: "#777777",
              height: "24px",
              alignSelf: "center",
            }}
          />

          <Badge
            badgeContent={cart_items.length}
            color="secondary"
            showZero
            sx={{
              "& .MuiBadge-badge": {
                color: "white",
                backgroundColor: "black",
              },
            }}
          >
            <ShoppingBagOutlinedIcon
              onClick={toggleCart}
              sx={{ color: "black", cursor: "pointer" }}
            />
          </Badge>

          <Divider
            orientation="vertical"
            flexItem
            sx={{
              borderColor: "#777777",
              height: "24px",
              alignSelf: "center",
            }}
          />

          <Badge
            badgeContent={data?.products?.length}
            color="secondary"
            showZero
            sx={{
              color: "black",
              "& .MuiBadge-badge": {
                color: "white",
                backgroundColor: "black",
              },
            }}
          >
            <FavoriteBorderIcon
              onClick={handleApi}
              sx={{ cursor: "pointer" }}
            />
          </Badge>
        </Box>

        {/* Mobile layout (below md) */}
        {/* Logo row */}
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            justifyContent: "center",
            width: "100%",
          }}
        >
          <img
            src={logo}
            alt="logo"
            onClick={refreshPage}
            className="familylogo"
            style={{ marginTop: "10px", cursor: "pointer" }}
          />
        </Box>

        {/* Icons row */}
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            px: 2,
          }}
        >
          {/* Left side - User icon */}
       
                <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
   <SearchIcon
              aria-label="SearchPage"
              onClick={() => setsearch(true)}
              sx={{ fontSize: 30, color: "black", cursor: "pointer" }}
            /> <Divider
              orientation="vertical"
              flexItem
              sx={{
                borderColor: "#777777",
                height: "24px",
                alignSelf: "center",
              }}
            />
            {!getuserdata?.token ? (
              <UserIcon
                onClick={() => setopenpopup("login")}
                sx={{ cursor: "pointer" }}
              />
            ) : (
             <p style={{ textTransform: "capitalize", paddingTop: "10px" }}>
  <Link
    to="/myAccount"
    style={{ textDecoration: "none", color: "black",
      cursor: "pointer",
     }}
  >
    My Account
  </Link>
</p>

            )}
          </Box>

          {/* Right side - Cart and Wishlist icons */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
            <Badge
              badgeContent={cart_items.length}
              color="secondary"
              showZero
              sx={{
                "& .MuiBadge-badge": {
                  color: "white",
                  backgroundColor: "black",
                },
              }}
            >
              <ShoppingBagOutlinedIcon
                onClick={toggleCart}
                sx={{ color: "black", cursor: "pointer" }}
              />
            </Badge>

            <Divider
              orientation="vertical"
              flexItem
              sx={{
                borderColor: "#777777",
                height: "24px",
                alignSelf: "center",
              }}
            />

            <Badge
              badgeContent={data?.products?.length}
              color="secondary"
              showZero
              sx={{
                color: "black",
                "& .MuiBadge-badge": {
                  color: "white",
                  backgroundColor: "black",
                },
              }}
            >
              <FavoriteBorderIcon
                onClick={handleApi}
                sx={{ cursor: "pointer" }}
              />
            </Badge>
          </Box>
        </Box>
      </Toolbar>

      <Searchpopup search={search} setsearch={setsearch}>
        <Searchbar search={search} setsearch={setsearch} />
      </Searchpopup>
    </>
  );
};

export default Headernewcentre;
